import { render, staticRenderFns } from "./sorting.vue?vue&type=template&id=52e87a0e&scoped=true"
import script from "./sorting.vue?vue&type=script&lang=js"
export * from "./sorting.vue?vue&type=script&lang=js"
import style0 from "./sorting.vue?vue&type=style&index=0&id=52e87a0e&prod&scoped=true&lang=less"
import style1 from "./sorting.vue?vue&type=style&index=1&id=52e87a0e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e87a0e",
  null
  
)

export default component.exports